import { useState } from 'react';
import { cn } from '@/lib/utils';

export function Tabs({ tabs, defaultActive, onChange, className }: {
  tabs: { id: string; label: string; count?: number }[];
  defaultActive?: string;
  onChange?: (id: string) => void;
  className?: string;
}) {
  const [active, setActive] = useState(defaultActive || tabs[0]?.id);

  const handleClick = (id: string) => {
    setActive(id);
    onChange?.(id);
  };

  return (
    <div className={cn('flex items-center gap-1 border-b border-border overflow-x-auto', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => handleClick(tab.id)}
          className={cn(
            'px-3 py-2 text-xs font-medium border-b-2 transition-colors whitespace-nowrap',
            active === tab.id
              ? 'border-accent text-text-primary'
              : 'border-transparent text-text-muted hover:text-text-secondary',
          )}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span className={cn('ml-1.5 text-2xs', active === tab.id ? 'text-accent' : 'text-text-disabled')}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}

export function TabContent({ active, tabId, children }: { active: string; tabId: string; children: React.ReactNode }) {
  if (active !== tabId) return null;
  return <div className="animate-fade-in">{children}</div>;
}
